/**
 * MSP web-side config.
 *
 * The frontend never calls the MSP REST API directly. All requests go through
 * the backend (`/api/v2/payments/msp/api-token` and `/api/v2/payments/create-order`).
 * The only browser-side config needed is the SDK environment ('test' or 'live')
 * so the dropin can be initialised against the correct MSP backend.
 */

export function getMspWebEnv() {
  return {
    environment: (import.meta.env.VITE_MSP_ENVIRONMENT || 'test').toLowerCase(),
  }
}

export function isMspWebConfigured() {
  const env = getMspWebEnv().environment  
  return env === 'test' || env === 'live'
}
